import {createAsyncThunk, createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { TableData } from '../../components/FlexibleTable';


export const getTables = createAsyncThunk("projects/getAggregated", async(params: { project?: string; hours?: number; acq?:string })=>{
  const { project, hours, acq } = params;
  const response = await fetch(process.env.REACT_APP_API_URI+"/projects/getAggregated?project="+project+"&hours="+hours+"&acq=undefined",{
      method:"GET",

  });
  const data = response.json()
  return data;

});

export const getAcqTables = createAsyncThunk("projects/getAggregatedAcq", async(params: { project?: string; hours?: number; acq?:string })=>{
  const { project, hours, acq } = params;
  const response = await fetch(process.env.REACT_APP_API_URI+"/projects/getAggregated?project="+project+"&hours="+hours+"&acq=defined",{
      method:"GET",

  });
  const data = response.json()
  return data;

});

// Define a type for the slice state
export interface AggregateState {
    tableData:TableData;
    acqTableData:TableData;
    current_project:number|null;
}

// Define the initial state using that type
const initialState: AggregateState = {
    tableData:{
      "columns": [],
      "data":[]
    },
    acqTableData:{
      "columns": [],
      "data":[]
    },
    current_project:0
}

interface TableRowPayload {
  row: (string | number | React.ReactNode)[];
  project?: number; // optional, can include project name/id
}


export const AggregateSlice = createSlice({
  name: 'Actions',
  initialState,
  reducers: {
    addTableRow: (state, action: PayloadAction<TableRowPayload>) => {
      const { row: newRow, project } = action.payload;
      if(project==state.current_project){
        const exists = state.tableData.data.some(row => {
          const oldTime = new Date(row[0] as string | number).getTime();
          const newTime = new Date(newRow[0] as string | number).getTime();
          return oldTime === newTime;
        });

        if (!exists) {
          state.tableData.data.unshift(newRow);
        }
    }
    },

    addAcqTableRow: (state, action: PayloadAction<TableRowPayload>) => {
      const { row: newRow, project } = action.payload;
      if(project==state.current_project){
        const exists = state.acqTableData.data.some(row => {
          const oldTime = new Date(row[0] as string | number).getTime();
          const newTime = new Date(newRow[0] as string | number).getTime();
          return oldTime === newTime;
        });

        if (!exists) {
          state.acqTableData.data.unshift(newRow);
        }
      }
    },

    setCurrentProject:(state, action: PayloadAction<number|null>)=>{
      state.current_project = action.payload;
    }

  },
  extraReducers: (builder) => {
    builder.addCase(getTables.fulfilled, (state, {payload}:PayloadAction<TableData>) => {
      state.tableData = payload;
    })
    builder.addCase(getAcqTables.fulfilled, (state, {payload}:PayloadAction<TableData>) => {
      state.acqTableData = payload;
    })
    
  }
});

export const { addAcqTableRow, addTableRow, setCurrentProject} = AggregateSlice.actions
export default AggregateSlice.reducer